export default __webpack_public_path__ + "static/media/icon-edit.67fc5137.svg";